import { WorkQueueDetails } from '@core/services/work-queue/work-queue.model';
import { Action } from '@ngrx/store';

export enum LenderReconciliationQueueActionTypes {
  LOAD_LENDERRECONCILIATIONQUEUE = '[LENDERRECONCILIATIONQUEUE] Load LenderReconciliationQueue',
  LOAD_LENDERRECONCILIATIONQUEUE_SUCCESS = '[LENDERRECONCILIATIONQUEUE] Load LenderReconciliationQueue Success',
  LOAD_LENDERRECONCILIATIONQUEUE_FAIL = '[LENDERRECONCILIATIONQUEUE] Load LenderReconciliationQueue Fail',
}

export class LOADLENDERRECONCILIATIONQUEUE implements Action {
  readonly type = LenderReconciliationQueueActionTypes.LOAD_LENDERRECONCILIATIONQUEUE;
  constructor(public payload: number, public queuetype: number, public workqueueStatusId: number, public accountUpdateOptionId: number, public customerFollowUpOptionId: number, public investigationOptionId: number, public insuranceFollowUpOptionId: number) { }
}

export class LOADLENDERRECONCILIATIONQUEUESUCCESS implements Action {
  readonly type = LenderReconciliationQueueActionTypes.LOAD_LENDERRECONCILIATIONQUEUE_SUCCESS;
  constructor(public payload: WorkQueueDetails) { }
}

export class LOADLENDERRECONCILIATIONQUEUEFAIL implements Action {
  readonly type = LenderReconciliationQueueActionTypes.LOAD_LENDERRECONCILIATIONQUEUE_FAIL;
  constructor(public payload: string) { }
}

export type LenderReconciliationQueueAction =
  | LOADLENDERRECONCILIATIONQUEUE
  | LOADLENDERRECONCILIATIONQUEUESUCCESS
  | LOADLENDERRECONCILIATIONQUEUEFAIL;
